export default __webpack_public_path__ + "static/media/powerofinsideinjuries.5a4dba4d.jpg";